<div class="sq-results-count">{{'msg#results.resultsCount' | sqMessage:{values: {count: rowCount} } }}</div>